// src/sections/Highlights.jsx
import Section from "../components/ui/Section";
import Button from "../components/ui/Button";
import Badge from "../components/ui/Badge";
import { Link } from "react-router-dom";
import { ArrowRight, Star, Zap, ShieldCheck } from "lucide-react";

const items = [
    {
        slug: "betonrohrfalle",
        title: "Betonrohrfalle",
        img: "/images/betonrohrfalle-product2.webp",
        desc: "Die robusteste Lösung für den dauerhaften Fangerfolg im Revier.",
        badge: "Bestseller",
        icon: ShieldCheck,
        tags: ["Wartungsfrei", "Vom Jäger"]
    },
    {
        slug: "abfangkasten",
        title: "Abfangkasten",
        img: "/images/abfangkasten-product2.webp",
        desc: "Stabil, praktikabel und in Sekunden einsatzbereit für die Entnahme.",
        icon: Star,
        tags: ["Leichte Bauweise", "Handlich"]
    },
    {
        slug: "fallenmelder",
        title: "Digitaler Melder",
        img: "/images/product_catchalive_716x404.webp",
        desc: "Echtzeit-Monitoring für maximale Effizienz bei der Fallenjagd.",
        badge: "Neu",
        icon: Zap,
        tags: ["Echtzeit-Alarm", "App-Anbindung"]
    },
];

export default function Highlights() {
    return (
        <Section
            eyebrow="Meine Favoriten"
            title="Produkt-Highlights"
            lead="Entdecke meine praxiserprobten Bestseller für dein Revier."
            className="relative overflow-hidden"
        >
            <div className="grid gap-6 lg:gap-8 sm:grid-cols-2 lg:grid-cols-3 pt-10">
                {items.map((p, idx) => (
                    <Link
                        to={`/produkt/${p.slug}`}
                        key={p.slug}
                        data-aos="fade-up"
                        data-aos-delay={idx * 100}
                        className="group relative flex flex-col rounded-3xl bg-white dark:bg-slate-900 border-2 border-slate-100 dark:border-slate-800 hover:border-brand-300 dark:hover:border-brand-700 transition-all duration-300 hover:shadow-xl hover:shadow-brand-500/10 overflow-hidden"
                    >
                        {/* Bildbereich */}
                        <div className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-900 p-8">
                            <img
                                src={p.img}
                                alt={p.title}
                                className="h-full w-full object-contain transition duration-500 group-hover:scale-105"
                                loading="lazy"
                            />
                            
                            {/* Badge */}
                            {p.badge && (
                                <div className="absolute left-4 top-4">
                                    <Badge className="bg-brand-600 text-white border-none shadow-lg">{p.badge}</Badge>
                                </div>
                            )}
                        </div>

                        {/* Content */}
                        <div className="p-6 flex flex-col flex-1">
                            {/* Tags */}
                            <div className="flex flex-wrap gap-2 mb-3">
                                {p.tags.map(t => (
                                    <span key={t} className="text-[10px] font-bold uppercase tracking-wider text-slate-400 bg-slate-100 dark:bg-slate-800 px-2 py-1 rounded-full">
                                        {t}
                                    </span>
                                ))}
                            </div>
                            
                            <h3 className="text-xl font-heading font-bold text-slate-900 dark:text-white group-hover:text-brand-600 transition-colors">
                                {p.title}
                            </h3>
                            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400 leading-relaxed flex-1">
                                {p.desc}
                            </p>

                            <div className="mt-5 flex items-center gap-2 text-sm font-bold text-brand-600">
                                <span>Jetzt ansehen</span>
                                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </Section>
    );
}